import { toast } from '@randstad-lean-mobile-factory/react-components-core';
import { UseQueryOptions, useQuery } from '@tanstack/react-query';

import { RoutingInfos, RoutingsService } from '../../Services/API';
import { QueryKeys } from '../types';

export const useFetchRoutingById = (
  id: string,
  extraOptions?: UseQueryOptions<RoutingInfos, unknown, RoutingInfos, (string | QueryKeys)[]>
) => {
  return useQuery(
    [QueryKeys.fetchRouting, id],
    async () => {
      return RoutingsService.routingsControllerGetRouting({ id });
    },
    {
      onError: () => {
        toast.error('Erreur lors de la récupération du routage');
      },
      enabled: Boolean(id),
      ...extraOptions,
    }
  );
};
